module.exports = __webpack_public_path__ + "img/icon-success-filled.e707fa62.svg";